<template>
  <Modal :open="open" @toggle-open="toggleOpen"  :external-open="true" alignButtons="right" size="md">
    <template #content>
      <div class="mt-6 flex flex-col gap-5 items-center">
        <img src="/craftable-pro/images/no-plan.svg" width="104" height="104" alt="qr code icon"/>
        <div>
          <div class="text-lg text-slate-900 font-semibold leading-8 items-center text-center">Sua jornada com a Rê precisa de um upgrade!
          </div>
          <div class="text-sm text-slate-600">
            Percebemos que seu acesso às funcionalidades completas da Recoloca.ai está pausado. <br/>Parece que seu plano atual não está ativo ou seu período de teste gratuito chegou ao fim.
            <br/>
Para continuar aproveitando o poder da Rê em sua recolocação profissional e não perder nenhuma oportunidade ative seu plano agora.
          </div>
        </div>
        <Alert type="info" >
          Não deixe sua carreira esperando. Ative seu plano e deixe a Rê continuar te guiando para o próximo nível!
        </Alert>
      </div>
    </template>
    <template #buttons="{ setIsOpen }" class="gap-1">
      <Button @click="
          () => {
            setIsOpen();
            router.visit(route('craftable-pro.plans.index'));
          }
        " color="success">
        Ativar plano
      </Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import {Alert, Button, Modal} from "craftable-pro/Components";
import {router} from "@inertiajs/vue3";

interface Props {
  open: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(["toggleOpen"]);

const toggleOpen = () => {
  emit("toggleOpen");
};
</script>
